import {Pipe, PipeTransform} from '@angular/core';
import { RaceAdditionalPricingItem,} from '@model';
import {TranslocoService} from "@ngneat/transloco";
import {getLanguageValue} from "@utility";
import {LocalizedDatePipe, FormatTimePipe} from "@pipes";
import {CompetitorTableRowData} from "@components";

@Pipe({
    name: 'competitorAdditionalPricingValue',
})
export class CompetitorAdditionalPricingValuePipe implements PipeTransform {
    constructor(private translocoService: TranslocoService, private localizedDatePipe: LocalizedDatePipe, private formatTimePipe: FormatTimePipe) {
    }

    transform(item: RaceAdditionalPricingItem, competitor: CompetitorTableRowData): string | undefined {
        const additionalItem: RaceAdditionalPricingItem | undefined = competitor.raceAdditionalItems?.find(
            (value: RaceAdditionalPricingItem): boolean => value.id === item.id
        );
        if (additionalItem) {
            if (additionalItem.pricingItemValues?.length) {
                const option = additionalItem.pricingItemValues.at(0);
                if (option) {
                    return getLanguageValue(
                        option.name,
                        option.nameEng,
                        option.nameIta,
                        option.nameSlo,
                        option.nameSr,
                        option.nameBs,
                        this.translocoService.getActiveLang(), option.name ?? option.nameEng ?? option.nameIta ?? option.nameSlo ?? option.nameSr ?? option.nameBs
                    );
                }
                return undefined;
            }
            return this.translocoService.translate("app.common.yes")
        }
        else {
            if (item.pricingItemValues?.length) {
                return "-"
            }
            return this.translocoService.translate("app.common.no")
        }
    }
}
